class Nav {
  constructor(navContainer, navButton) {
    this.navConatiner = document.querySelector(navContainer);
    this.navButton = document.querySelector(navButton);
  }

  toggleNav() {
    if (this.navButton) {
      this.navButton.addEventListener('click', () => {

        let phoneModal = document.querySelector('.js-phone-modal');
        let phoneModalCurrentState = phoneModal.classList.contains('phone-modal-off');
        let currentClickButtonState = this.navButton.classList.contains('js-nav-button');
        let subNavContainer = document.querySelectorAll('.menu-item-has-children');
        let navList = this.navConatiner.querySelector('.nav');

        if (phoneModalCurrentState === false) {
          phoneModal.classList.add('phone-modal-off');
        }

        subNavContainer.forEach((el) => {
          if (el.classList.contains('js-nav-on')) {
            el.classList.remove('js-nav-on');

            let elActive = el.querySelector('.sub-menu');

            elActive.classList.remove('js-subnav-on');
            elActive.classList.remove('animated');
            elActive.classList.remove('fadeInUp');
          }
        });

        if (currentClickButtonState === true) {
          let mobileCategoryNav = document.querySelector('.js-categories-container');
          mobileCategoryNav.classList.add('js-nav-off');
        }

        this.navConatiner.classList.toggle('js-nav-off');

        navList.classList.toggle('animated');
        navList.classList.toggle('slideInLeft');
      })
    }
  }
}

class SubNav {
  constructor(subNavButton) {
    this.subNavButton = document.querySelectorAll(subNavButton);
  }

  toggleSubNav() {
    if (this.subNavButton) {
      this.subNavButton.forEach(el => {
        el.addEventListener('click', (e) => {

          let subNavContainer = el.querySelector('.sub-menu');

          el.classList.toggle('js-nav-on');

          this.toggleNavAnimation(subNavContainer);

          // REMOVE SIBLINGS OPENED SUBMENUS

          let clickElement = e.target;

          if (clickElement.classList.contains('menu-item-has-children')) {

            let siblingsElement = getAllSiblings(clickElement);

            siblingsElement.forEach((el) => {
              if (el.classList.contains('js-nav-on')) {
                el.classList.remove('js-nav-on');

                let childOfActiveSiblings = el.querySelector('.sub-menu');

                childOfActiveSiblings.classList.remove('js-subnav-on');
                childOfActiveSiblings.classList.remove('animated');
                childOfActiveSiblings.classList.remove('fadeInUp');
              }
            });

          } else {

            let siblingsElement = getAllSiblings(clickElement.parentNode);

            siblingsElement.forEach((el) => {
              if (el.classList.contains('js-nav-on')) {
                el.classList.remove('js-nav-on');

                let childOfActiveSiblings = el.querySelector('.sub-menu');

                childOfActiveSiblings.classList.remove('js-subnav-on');
                childOfActiveSiblings.classList.remove('animated');
                childOfActiveSiblings.classList.remove('fadeInUp');

              }
            });
          }


          let phoneModal = document.querySelector('.js-phone-modal');
          let phoneModalCurrentState = phoneModal.classList.contains('phone-modal-off');
          let categoryMenuButton = document.querySelector('.js-categories-container');

          categoryMenuButton.classList.add('js-nav-off');

          let navChildList = categoryMenuButton.querySelector('.nav');
          navChildList.classList.remove('animated');
          navChildList.classList.remove('slideInLeft');

          if (phoneModalCurrentState === false) {
            phoneModal.classList.add('phone-modal-off');
          }

        });
      })
    }
  }

  toggleNavAnimation(element) {
    element.classList.toggle('js-subnav-on');
    element.classList.toggle('animated');
    element.classList.toggle('fadeInUp');
  }
}

const getAllSiblings = (element) => {
  let siblings = [];
  let sibling = element.parentNode.firstChild;

  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== element) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }

  return siblings;
};


export {Nav, SubNav} ;


// WEBPACK FOOTER //
// ./scripts/modules/nav.js